module.exports = __webpack_public_path__ + "static/img/SketchPng9d772d71b64a792c78d169d38b3f76d17ed2849031cbff775c7e71fe8d6e87f7.fad4eecd.png";